import { IAutoRegionConfig } from '../../../interfaces/auto';
import coverageConfigs from '../coverageConfigs';

const TNConfig: IAutoRegionConfig = {
  coverages: [
    coverageConfigs.BODILY_INJURY_LIMIT(),
    coverageConfigs.COLLISION_DEDUCTIBLE(),
    coverageConfigs.COMPREHENSIVE_DEDUCTIBLE(),
    coverageConfigs.GAP(),
    coverageConfigs.MEDICAL_LIMIT(),
    coverageConfigs.NEW_CAR_REPLACEMENT(),
    coverageConfigs.OEM_PARTS(),
    coverageConfigs.PET_PASSENGER(),
    coverageConfigs.PROPERTY_DAMAGE_LIMIT(),
    coverageConfigs.SIDE_HUSTLE(),
    coverageConfigs.TEMPORARY_RIDE(),
    coverageConfigs.TOWING_ROAD_SERVICES(),
    coverageConfigs.UNINSURED_MOTORIST_BODILY_INJURY_LIMIT(),
    coverageConfigs.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIMIT(),
  ],
};

export default TNConfig;
